import React from "react";
import { FieldRenderProps } from "react-final-form";
import { FormFieldProps, Form, Label } from "semantic-ui-react";
import { DateTimePicker } from "react-widgets";

interface IProps extends FieldRenderProps<any, HTMLElement>, FormFieldProps {}

const DateInput: React.FC<IProps> = ({
  input,
  width,
  placeholder,
  title,
  date = false,
  time = false,
  meta: { touched, error },
  ...rest
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      {title && <label>{title}</label>}
      <DateTimePicker
        placeholder={placeholder}
        value={input.value === "" ? undefined : new Date(input.value)}
        onChange={input.onChange}
        //onKeyDown={(e) => e.preventDefault()}
        date={date}
        time={time}
        format="dd/MM/yyyy"
        {...rest}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DateInput;
